import { jsx as _jsx } from "react/jsx-runtime";
import { InputAdornment as MuiInputAdornment, } from '@mui/material';
import { forwardRef, } from 'react';
import { NumericFormat, } from 'react-number-format';
import { TextField } from '../TextField/';
// FIXME: move generic logic of NumberFormat fields into base component to avoid duplicate code
export const NumberFormatPercentage = forwardRef(function NumberFormatPercentage(props, ref) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { getInputRef, onChange, value, ...other } = props;
    // We need to handle 0 and null as empty cases as rnf resets to 0
    // and we want to clear the field (also resetting format when empty)
    const isEmpty = value === null;
    return (_jsx(NumericFormat, { ...other, getInputRef: ref, onValueChange: (values) => {
            if (onChange) {
                onChange({
                    target: { value: values.value },
                    floatValue: values.floatValue ?? 0,
                });
            }
        }, isAllowed: (values) => {
            // fix to 99,99 max
            const { floatValue } = values;
            return floatValue ? floatValue < 100 : true;
        }, fixedDecimalScale: !isEmpty, value: value, decimalSeparator: ",", thousandSeparator: ".", valueIsNumericString: true, allowNegative: false, decimalScale: isEmpty ? 0 : 2 }));
});
export const PercentageField = forwardRef(function PercentageField({ InputProps, onChange, onBlur, value, ...props }, ref) {
    return (_jsx(TextField, { ...props, ref: ref, value: value, InputProps: {
            endAdornment: _jsx(MuiInputAdornment, { position: "end", children: "%" }),
            inputComponent: 
            // FIXME: onChange is incompatible of course! This should be done completely differently!
            NumberFormatPercentage,
            ...(InputProps || {}),
        }, onChange: (e) => {
            if (onChange && 'floatValue' in e) {
                // FIXME: Type-guards come to mind here. But I think the whole component should be changed so we don't need to pass differently typed onChange functions.
                const customEvent = e;
                onChange(customEvent.floatValue);
            }
        }, onBlur: () => {
            if (onBlur)
                onBlur(value ?? 0);
        } }));
});
